import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import KeyDownEvent = JQuery.KeyDownEvent;

@Directive({
    selector: '[maximumEnforce]'
})
export class MaximumEnforceDirective {

    // Properties
    @Input() allowDecimal = false;
    @Input() maximumEnforce: number;

    private allowedKeys: Array<string> = [
        'Backspace',
        'End',
        'Home',
        'ArrowRight',
        'ArrowLeft',
        'Tab',
        'Delete'
    ];
    private disallowedKeys: Array<string> = [' '];

    constructor(private el: ElementRef) {}

    @HostListener('keydown', [ '$event' ])
    onKeyDown(event: KeyDownEvent) {

        // Allow some characters without doing anything
        if (this.allowedKeys.includes(event.key) || !this.maximumEnforce) {
            return;
        }

        // Don't allow certain characters at all
        if (this.disallowedKeys.includes(event.key)) {
            event.preventDefault();
        }

        // Obtaining the new value
        let current: string = this.el.nativeElement.value;
        const indexStart = event.target.selectionStart;
        const indexEnd = event.target.selectionEnd;
        const key = event.key;
        const next: string = current.slice(0, indexStart) + key + current.slice(indexEnd + Math.abs(0));
        const nextNumber = Number(next);

        // If we just have a hyphen, that's allowed because of negatives
        if (next == '-') {
            return;
        }

        // If we have just a decimal and we allove decimals, let that be
        if (next == '.' && this.allowDecimal) {
            return;
        }

        // Checking the new value
        if (next
            && (this.allowDecimal || !next.includes('.'))
            && !isNaN(nextNumber)
            && parseFloat(next) <= this.maximumEnforce
        ) {
            return;
        }

        // Preventing if we haven't allowed it yet
        event.preventDefault();
        return;
    }
}
